import React from 'react';
import styled from 'styled-components';
import { FONT_FAMILY, COLORS, MQS } from '../../app/common/constants/styles';
import { TranslationHelpers } from '../../i18n/translationHelpers';
import { injectIntl, InjectedIntlProps } from 'react-intl';

export const ServiceContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 16px;
    @media (max-width: ${MQS.mq2Min}) {
    }
`;
export const Button = styled.div`
    align-items: center;
    background-color: transparent;
    display: flex;
    ${FONT_FAMILY.multipleRegularCss};
    font-size: 1rem;
    font-weight: 300;
    justify-content: center;
    line-height: 1;
    margin: 8px 20px;
    max-width: 100px;
    max-height: 16px;
    overflow-wrap: break-word;
    opacity: 1;
    padding: 15px;
    transition: opacity 0.1s;
    word-break: break-word;
    color: #d80000;
    &:hover,
    &:active {
        border-radius: 4px;
        cursor: pointer;
        opacity: 0.8;
        background-color: ${COLORS.grey8};
    }

    &:hover &:disabled,
    &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }
    svg {
        margin-right: 10px;
        height: 20px;
    }
`;

const ServiceName = styled.span`
    & data {
        ${FONT_FAMILY.multipleBoldCss};
        white-space: no-wrap;
        justify-content: flex-end;
        color: ${(props) => props.color as string};
    }
`;

export const ServiceLink = ({
    onClick,
    clientId,
}: {
    onClick: () => void;
    clientId: string;
} & InjectedIntlProps) => {
    return (
        <ServiceContainer>
            <ServiceName>
                {TranslationHelpers.getFormattedMessage(`ekyc.service.${clientId}`)}
            </ServiceName>
            <Button onClick={onClick} data-qa-id={`service-button`}>
                <span>{TranslationHelpers.getFormattedMessage('button.unlink')}</span>
            </Button>
        </ServiceContainer>
    );
};

export const ServiceLinkButton = injectIntl(ServiceLink);
